const OnboardingAssignment = () => {
  return (
    <div>assignment</div>
  )
}

export default OnboardingAssignment
